export default __webpack_public_path__ + "static/media/logo.be0455f2.png";